import React from "react";
import { useTranslation } from "react-i18next";
import { GlobeSimple } from "@phosphor-icons/react";

const LanguageSelector = ({ onClick }) => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;

  const handleLanguageChange = () => {
    // Toggle between English and Arabic
    const newLanguage = currentLanguage === "en" ? "ar" : "en";

    i18n.changeLanguage(newLanguage);
    // Set direction for RTL/LTR based on language
    document.documentElement.dir = newLanguage === "ar" ? "rtl" : "ltr";
    document.documentElement.lang = newLanguage;

    // Store language preference in localStorage
    localStorage.setItem("i18nextLng", newLanguage);

    // Call onClick if provided (for mobile menu)
    if (onClick) {
      onClick();
    }

    // Reload the page to ensure all components render with the new language
    window.location.reload();
  };

  return (
    <button
      className="relative bg-primary text-white px-4 py-2 text-xl flex items-center justify-center rounded-md"
      onClick={handleLanguageChange}
      title={t("language.changeLanguage")}
    >
      <GlobeSimple />
      <span className="absolute -top-1 right-1 bg-dark text-white p-1 w-4 h-4 flex items-center justify-center rounded-full text-[10px]">
        {currentLanguage.toUpperCase()}
      </span>
    </button>
  );
};

export default LanguageSelector;
